import React, { useEffect, useState } from "react";

import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";

import "./FlashcardFinishModal.css";

export default function FlashcardFinishModal({ reviewedCount, onClose }) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Play a soft sound (optional)
    const audio = new Audio("/sounds/flashcardfinish.mp3");
    audio.volume = 0.4;
    audio.play().catch(() => {});

    if (analytics) {
      logEvent(analytics, "flashcards_practice_completed", {
        reviewed_count: reviewedCount
      });
    }

    setTimeout(() => setAnimate(true), 300);

    launchConfetti();
  }, []);

  const launchConfetti = () => {
    const colors = ["var(--color-primary)", "#22c55e", "#facc15", "#ef4444", "#a855f7"];
    for (let i = 0; i < 25; i++) {
      const piece = document.createElement("div");
      piece.className = "confetti";
      piece.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      piece.style.left = Math.random() * 100 + "vw";
      piece.style.width = piece.style.height = Math.random() * 8 + 6 + "px";
      document.body.appendChild(piece);
      setTimeout(() => piece.remove(), 2200);
    }
  };

  return (
    <div className="finish-overlay">
      <div className="finish-modal">
        <button className="finish-close-x" onClick={onClose}>✕</button>

        <div className="finish-emoji pulse">🎉</div>

        <h2 className="finish-title"> Sessão concluída!</h2>

        <p className="finish-subtitle">
            Você acabou de treinar seu cérebro como um atleta treina o corpo. Bora!
        </p>

        <ul className="finish-achievements">
          <li className={animate ? "visible" : ""}>
            🔁 Você revisou {reviewedCount} flashcard{reviewedCount > 1 ? "s" : ""}
          </li>
          <li className={animate ? "visible" : ""}>
            🧠 Memória fortalecida
          </li>
          <li className={animate ? "visible" : ""}>
            📚 Seu vocabulário fica mais forte a cada palavra
          </li>
          <li className={animate ? "visible" : ""}>
            🚀 Continue praticando diariamente!
          </li>
        </ul>

        <button className="finish-close-btn" onClick={onClose}>
          Voltar
        </button>
      </div>
    </div>
  );
}
